/** Client-side mirror of the server limits (app/services/feedback_files.py). */
export const MAX_ATTACHMENTS = 5
export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024
export const ACCEPTED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'application/pdf',
] as const
export const ACCEPT_ATTRIBUTE = ACCEPTED_TYPES.join(',')

export interface AttachmentError {
  code: 'type' | 'size' | 'count'
  name: string
}

/**
 * Split the incoming files into the ones to keep and the ones to refuse.
 *
 * Only a fast answer for the user: the server checks the real type from the
 * bytes and the limits again.
 */
export function validateAttachments(
  existing: File[],
  incoming: File[],
  maxFiles: number,
): { accepted: File[]; errors: AttachmentError[] } {
  const accepted: File[] = []
  const errors: AttachmentError[] = []
  let overflow = false
  for (const file of incoming) {
    if (!(ACCEPTED_TYPES as readonly string[]).includes(file.type)) {
      errors.push({ code: 'type', name: file.name })
    } else if (file.size > MAX_ATTACHMENT_SIZE) {
      errors.push({ code: 'size', name: file.name })
    } else if (existing.length + accepted.length >= maxFiles) {
      if (!overflow) errors.push({ code: 'count', name: file.name })
      overflow = true
    } else {
      accepted.push(file)
    }
  }
  return { accepted, errors }
}
